import { render, staticRenderFns } from "./StudyResultsHeader.vue?vue&type=template&id=0d4a2082&"
import script from "./StudyResultsHeader.vue?vue&type=script&lang=js&"
export * from "./StudyResultsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports